<template>
  <vs-popup
    class="holamundo"
    :title="'Boletos Excluídos'"
    :active.sync="popupBoletosExcluidos"
    @close="popupBoletosExcluidos = false"
  >
    <vs-alert
      v-if="!dadosBoletosExcluidos.length"
      class="my-3 text-left"
      style="height: auto"
      type="info"
    >
      Nenhum boleto encontrado
    </vs-alert>

    <vs-collapse v-else type="border">
      <vs-collapse-item
        v-for="item in dadosBoletosExcluidos"
        :key="item.id_boleto"
      >
        <div slot="header">
          <!-- Chip - Placa -->
          <template v-if="item.veiculos">
            <vs-chip
              v-for="veiculo in item.veiculos"
              :key="veiculo.id_veiculo"
              class="mr-4"
              color="dark"
            >
              {{ veiculo.placa }}
            </vs-chip>
          </template>

          <!-- Chip - Situacao -->
          <vs-chip
            v-if="item.situacao"
            class="mr-4"
            :color="getStatusBoletoColor(item.situacao)"
          >
            {{ item.situacao }}
          </vs-chip>

          <!-- Chip - Status -->
          <vs-chip class="mr-4" color="danger"> EXCLUÍDO </vs-chip>

          {{ formatarDescricaoItem(item) }}
        </div>

        <vs-row>
          <vs-col
            class="text-right"
            v-if="$can('Pode editar boletos', 'Associados')"
          >
            <vs-button
              color="warning"
              type="gradient"
              class="mb-2 text-white forceWhite mr-3"
              @click="openModalReabrirCobranca(item)"
              v-if="
                $can('Pode reabrir cobrança', 'Associados') && !item.situacao
              "
            >
              <vs-icon
                icon-pack="feather"
                icon="icon-refresh-ccw"
                class="mr-3"
              ></vs-icon>
              Reabrir Cobrança
            </vs-button>

            <!-- Botão - Baixar Cobrança -->
            <vs-button
              color="success"
              type="gradient"
              class="mb-2 text-white forceWhite mr-3"
              @click="openModalBaixarBoleto(item)"
              v-if="
                $can('Alterar Produtos', 'Veículos') &&
                $can('Pode editar boletos', 'Associados') &&
                $can('Pode baixar cobrança', 'Associados') &&
                !item.situacao
              "
            >
              <vs-icon
                icon-pack="feather"
                icon="icon-check-circle"
                class="mr-3"
              ></vs-icon>
              Baixar Cobrança
            </vs-button>
          </vs-col>
        </vs-row>

        <vs-row>
          <table class="table table-bordered">
            <tr v-if="item.nosso_numero">
              <th class="uppercase">Nosso Número</th>
              <td>{{ item.nosso_numero }}</td>
            </tr>

            <tr>
              <th class="uppercase">Boleto Físico</th>
              <td>
                {{ formataBoletoFisico(item) }}
              </td>
            </tr>

            <tr>
              <th class="uppercase">Data de Emissão</th>
              <td>
                {{ formataData(item.data_emissao) }}
              </td>
            </tr>

            <tr>
              <th class="uppercase">Data de Vencimento</th>
              <td>
                {{ formataDataUTCAux(item.data_vencimento) }}
              </td>
            </tr>

            <tr v-if="item.data_pagamento">
              <th class="uppercase">Data de Pagamento</th>
              <td>
                {{ formataData(item.data_pagamento) }}
              </td>
            </tr>

            <tr v-if="item.dataBaixaManual">
              <th class="uppercase">Baixa Manual</th>
              <td>
                em {{ formataData(item.dataBaixaManual) }}, por
                {{ item.userBaixadoPor }}
              </td>
            </tr>

            <tr>
              <th class="uppercase">Valor</th>
              <td>{{ item.valor_boleto | currency }}</td>
            </tr>

            <tr v-if="item.valor_pagamento">
              <th class="uppercase">Valor Pago</th>
              <td>
                {{ item.valor_pagamento | currency }}
              </td>
            </tr>

            <tr v-if="item.linha_digitavel">
              <th class="uppercase">Linha Digitavel</th>
              <td>{{ item.linha_digitavel }}</td>
            </tr>

            <tr v-if="item.linha_digitavel">
              <th class="uppercase">Link Boleto</th>
              <td>
                <router-link
                  target="_blank"
                  :to="`/Boleto/${item.id_boleto}?nn=${item.nosso_numero}`"
                  >Visualizar Boleto</router-link
                >
              </td>
            </tr>

            <tr v-if="item.observacao">
              <th class="uppercase">Observação</th>
              <td style="word-break: break-all">
                {{ item.observacao }}
              </td>
            </tr>

            <tr v-if="item.motivoCancelamentoExclusao">
              <th class="uppercase">Motivo Exclusão</th>
              <td style="word-break: break-all">
                {{ item.motivoCancelamentoExclusao }}
              </td>
            </tr>

            <tr v-if="item.deletedAt">
              <th class="uppercase">Data Exclusão</th>
              <td style="word-break: break-all">
                {{ formataData(item.deletedAt) }}
              </td>
            </tr>

            <tr v-if="item.situacao">
              <th class="uppercase">Histórico de Baixa</th>
              <td style="word-break: break-all">
                {{
                  item.situacao.toUpperCase() == 'BAIXADO'
                    ? 'Existe Histórico de Baixa!'
                    : 'Não Existe Histórico de Baixa'
                }}
              </td>
            </tr>
          </table>
        </vs-row>

        <vs-row v-if="item.veiculos">
          <table
            class="table table-bordered"
            style="border-top: 1px solid black"
          >
            <tr>
              <th class="uppercase">Veiculo</th>
              <th class="uppercase text-center">Placa</th>
            </tr>
            <tr v-for="veiculo in item.veiculos" :key="veiculo.id">
              <td>{{ veiculo.veiculoModelo }}</td>
              <td class="text-center" valing="top">
                {{ veiculo.placa }}
              </td>
            </tr>
          </table>
        </vs-row>
      </vs-collapse-item>
    </vs-collapse>
  </vs-popup>
</template>

<script>
export default {
  name: 'ModalBoletosExcluidos',

  props: [
    'dadosBoletosExcluidos',
    'formataDataUTCAux',
    'formataBoletoFisico',
    'formataData',
    'getStatusBoletoColor',
  ],

  data() {
    return {
      popupBoletosExcluidos: false,
    };
  },

  watch: {
    dadosBoletosExcluidos(value) {
      this.popupBoletosExcluidos = value.length > 0 ? true : false;
    },
  },

  methods: {
    formatarDescricaoItem(item) {
      let str = '';

      item.descricao && (str += item.descricao);
      item.mes_referente && (str += ` ${item.mes_referente}`);
      item.data_vencimento &&
        (str += ` ${this.formataDataUTCAux(item.data_vencimento)}`);
      item.tipoBoleto && (str += ` - ${item.tipoBoleto}`);

      return str;
    },
    openModalBaixarBoleto(item) {
      this.$emit('openModalBaixarBoleto', item);
    },
    openModalReabrirCobranca(item) {
      this.$emit('openModalReabrirCobranca', item);
    },
  },
};
</script>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
